// extracted by mini-css-extract-plugin
module.exports = {"Section":"Section_Section__2qRef","Open":"Section_Open__2AQ-F","Header":"Section_Header__4Pnr8","Icon":"Section_Icon__Jo9yS"};